import {
  GET_STATS_BEGIN,
  GET_STATS_FAILURE,
  GET_STATS_SUCCESS,
  SET_STATS_TIME_FRAME,
  STATS_CLEAR,
} from './../../_types'
import { set } from 'vue';
import analyticsAPI from '@api/analytics'
import { formatISO, subDays } from 'date-fns'

const getDefaultState = () => {
  return {
    timeFrame: {
      from: '',
      to: '',
      label: '',
    },
    campaignStatsObject: {},
    getStatsErrorMessage: '',
    getStatsCompleted: false,
    getStatsError: false,
    getStatsLoading: false,
  }
}

export const state = getDefaultState()

export const getters = {
  allCampaignImpressionsByUUID: (state) => (uuid) => {
    // Ensure the array exists and is not undefined; default to an empty array if necessary
    const widgets = state.campaignStatsObject[uuid] || []

    // Use reduce for accumulation, ensuring each total is a number and defaulting to 0 if nullish
    return widgets.reduce((sum, widget) => {
      return sum + (Number(widget.impressions?.total) || 0)
    }, 0)
  },
  allCampaignConversionsByUUID: (state) => (uuid) => {
    const widgets = state.campaignStatsObject[uuid] || []

    return widgets.reduce((sum, widget) => {
      return sum + (Number(widget.conversions?.total) || 0)
    }, 0)
  },
  allCampaignLeadsByUUID: (state) => (uuid) => {
    let totalLeads = 0

    state.campaignStatsObject[uuid].forEach((widget) => {
      totalLeads += widget.leads.total
    })

    return totalLeads
  },
}

export const mutations = {
  [GET_STATS_BEGIN](state) {
    state.getStatsLoading = true
    state.getStatsCompleted = false
    state.getStatsError = false
  },
  [GET_STATS_SUCCESS](state, response) {
    for (const key in response) {
        set(state.campaignStatsObject, key, response[key]);
    }

    state.getStatsCompleted = true
    state.getStatsLoading = false
  },
  [GET_STATS_FAILURE](state) {
    state.getStatsError = true
    state.getStatsLoading = false
    state.getStatsCompleted = true
  },
  [SET_STATS_TIME_FRAME](state, { fromDate, toDate, label }) {
    state.timeFrame.from = fromDate
    state.timeFrame.to = toDate
    state.timeFrame.label = label
  },
  [STATS_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  getCampaignStats(
    { commit, dispatch, rootState }, { uuid, fromDate, toDate, label }) {
    commit(GET_STATS_BEGIN)

    if (!label) {
      label = 'last7Days'
      toDate = formatISO(new Date(), { representation: 'date' })
      fromDate = formatISO(subDays(new Date(), 7), { representation: 'date' })
    }

    if (rootState.campaign.currentCampaignsList.length === 0) {
      // There is no campaign for this user
      commit(SET_STATS_TIME_FRAME, { fromDate, toDate, label })
      commit(GET_STATS_SUCCESS, {})
      return
    } else if (!uuid) {
      uuid = rootState.campaign.currentCampaignsList[0].uuid
    }

    return analyticsAPI.getCampaignStats(uuid, fromDate, toDate)
      .then((response) => {
        commit(SET_STATS_TIME_FRAME, { fromDate, toDate, label })
        const responseData = {}
        responseData[uuid] = response.data

        commit(GET_STATS_SUCCESS, responseData)
        dispatch('campaign/setTargetCampaign', uuid, { root: true })
      }).catch((errorMessage) => commit(GET_STATS_FAILURE))
  },
  getAllCampaignsStats({ commit, dispatch }) {
    commit(GET_STATS_BEGIN)

    return analyticsAPI.getAllCampaignsStats().then((response) => {
      // const responseData = response.data
      commit(GET_STATS_SUCCESS, response.data)
    }).catch(() => commit(GET_STATS_FAILURE))
  },
  clearState({ commit }) {
    commit(STATS_CLEAR)
  },
}
